import { AppliedBillableConceptResponse } from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.dto'
import { BillingGridDatasource } from '@/modules/billing-module/components/grid/config/datasources/billing-grid.datasource'
import { CrudModelBase, initialCrudModelBaseState } from '@/shared/models/cruds.models'
import { billingGridCasesDetailColumnDefs } from '@/modules/billing-module/components/grid/config/column-defs/billing-grid-cases-detail.column-defs'

export type BillingGridBottomPanelState<R = AppliedBillableConceptResponse> = CrudModelBase<R, BillingGridDatasource<R>>
export const initialBillingGridState =
    (): BillingGridBottomPanelState => ({
        ...initialCrudModelBaseState(),
        columnsDef: billingGridCasesDetailColumnDefs()
    })
